import { 
    Users, 
    Briefcase, 
    CheckSquare, 
    Mail, 
    TrendingUp,
    DollarSign,
    Clock,
    Award,
    ArrowUp,
    ArrowDown
  } from 'lucide-react';
  
  const Dashboard = () => {
    // Sample statistics data
    const stats = [
      {
        title: 'Total Employees',
        value: '248',
        change: '+12%',
        isPositive: true,
        icon: Users,
        color: '#3b82f6',
        bgColor: '#dbeafe',
      },
      {
        title: 'Active Projects',
        value: '32',
        change: '+8%',
        isPositive: true,
        icon: Briefcase,
        color: '#8b5cf6',
        bgColor: '#ede9fe',
      },
      {
        title: 'Pending Tasks',
        value: '156',
        change: '-5%',
        isPositive: false,
        icon: CheckSquare,
        color: '#f59e0b',
        bgColor: '#fef3c7',
      },
      {
        title: 'New Enquiries',
        value: '48',
        change: '+23%',
        isPositive: true,
        icon: Mail,
        color: '#10b981',
        bgColor: '#d1fae5',
      },
      {
        title: 'Total Revenue',
        value: '₹45.2L',
        change: '+18%',
        isPositive: true,
        icon: DollarSign,
        color: '#06b6d4',
        bgColor: '#cffafe',
      },
      {
        title: 'Avg Response Time',
        value: '2.4h',
        change: '-15%',
        isPositive: true,
        icon: Clock,
        color: '#ec4899',
        bgColor: '#fce7f3',
      },
      {
        title: 'Customer Satisfaction',
        value: '94%',
        change: '+3%',
        isPositive: true,
        icon: Award,
        color: '#14b8a6',
        bgColor: '#ccfbf1',
      },
      {
        title: 'Growth Rate',
        value: '28%',
        change: '+7%',
        isPositive: true,
        icon: TrendingUp,
        color: '#f97316',
        bgColor: '#ffedd5',
      },
    ];
  
    const recentActivities = [
      { id: 1, title: 'New employee onboarded', user: 'Rahul Sharma', time: '2 hours ago' },
      { id: 2, title: 'Project milestone completed', user: 'Priya Singh', time: '4 hours ago' },
      { id: 3, title: 'New enquiry received', user: 'Customer Portal', time: '5 hours ago' },
      { id: 4, title: 'Invoice generated', user: 'Amit Kumar', time: '6 hours ago' },
      { id: 5, title: 'Leave approved', user: 'HR Department', time: '1 day ago' },
    ];
  
    const upcomingTasks = [
      { id: 1, title: 'Review quarterly reports', deadline: 'Today, 5:00 PM', priority: 'High' },
      { id: 2, title: 'Client meeting preparation', deadline: 'Tomorrow, 10:00 AM', priority: 'Medium' },
      { id: 3, title: 'Team performance review', deadline: 'Jan 25, 2026', priority: 'High' },
      { id: 4, title: 'Update project timeline', deadline: 'Jan 26, 2026', priority: 'Low' },
      { id: 5, title: 'Vendor payment processing', deadline: 'Jan 27, 2026', priority: 'Medium' },
    ];
  
    const styles = {
      container: {
        width: '100%',
      },
      welcomeSection: {
        marginBottom: '30px',
      },
      welcomeTitle: {
        fontSize: '28px',
        fontWeight: '600',
        color: '#1e293b',
        marginBottom: '8px',
      },
      welcomeSubtitle: {
        fontSize: '16px',
        color: '#64748b',
      },
      statsGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
        gap: '20px',
        marginBottom: '30px',
      },
      statCard: {
        backgroundColor: '#ffffff',
        borderRadius: '12px',
        padding: '24px',
        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
        transition: 'transform 0.2s ease, box-shadow 0.2s ease',
        cursor: 'pointer',
      },
      statHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        marginBottom: '16px',
      },
      iconBox: {
        width: '48px',
        height: '48px',
        borderRadius: '12px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      },
      statTitle: {
        fontSize: '14px',
        color: '#64748b',
        marginBottom: '8px',
      },
      statValue: {
        fontSize: '32px',
        fontWeight: '700',
        color: '#1e293b',
        marginBottom: '8px',
      },
      statChange: {
        fontSize: '14px',
        fontWeight: '600',
        display: 'flex',
        alignItems: 'center',
        gap: '4px',
      },
      contentGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))',
        gap: '20px',
        marginBottom: '30px',
      },
      card: {
        backgroundColor: '#ffffff',
        borderRadius: '12px',
        padding: '24px',
        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
      },
      cardTitle: {
        fontSize: '18px',
        fontWeight: '600',
        color: '#1e293b',
        marginBottom: '20px',
        paddingBottom: '12px',
        borderBottom: '2px solid #f1f5f9',
      },
      activityItem: {
        padding: '12px 0',
        borderBottom: '1px solid #f1f5f9',
      },
      activityTitle: {
        fontSize: '14px',
        fontWeight: '500',
        color: '#1e293b',
        marginBottom: '4px',
      },
      activityMeta: {
        fontSize: '12px',
        color: '#64748b',
        display: 'flex',
        justifyContent: 'space-between',
      },
      taskItem: {
        padding: '12px',
        marginBottom: '8px',
        borderRadius: '8px',
        backgroundColor: '#f8fafc',
        border: '1px solid #e2e8f0',
        transition: 'all 0.2s ease',
        cursor: 'pointer',
      },
      taskHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '4px',
      },
      taskTitle: {
        fontSize: '14px',
        fontWeight: '500',
        color: '#1e293b',
      },
      priorityBadge: {
        padding: '4px 12px',
        borderRadius: '12px',
        fontSize: '11px',
        fontWeight: '600',
      },
      taskDeadline: {
        fontSize: '12px',
        color: '#64748b',
      },
    };
  
    const getPriorityColor = (priority) => {
      switch (priority) {
        case 'High':
          return { bg: '#fee2e2', color: '#dc2626' };
        case 'Medium':
          return { bg: '#fef3c7', color: '#f59e0b' };
        case 'Low':
          return { bg: '#dbeafe', color: '#3b82f6' };
        default:
          return { bg: '#f1f5f9', color: '#64748b' };
      }
    };
  
    return (
      <div style={styles.container}>
        {/* Welcome Section */}
        <div style={styles.welcomeSection}>
          <h1 style={styles.welcomeTitle}>Welcome back! 👋</h1>
          <p style={styles.welcomeSubtitle}>
            Here's what's happening with your business today.
          </p>
        </div>
  
        {/* Statistics Grid */}
        <div style={styles.statsGrid}>
          {stats.map((stat, index) => {
            const Icon = stat.icon;
            return (
              <div
                key={index}
                style={styles.statCard}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-4px)';
                  e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.15)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 1px 3px rgba(0, 0, 0, 0.1)';
                }}
              >
                <div style={styles.statHeader}>
                  <div>
                    <div style={styles.statTitle}>{stat.title}</div>
                    <div style={styles.statValue}>{stat.value}</div>
                    <div
                      style={{
                        ...styles.statChange,
                        color: stat.isPositive ? '#10b981' : '#ef4444',
                      }}
                    >
                      {stat.isPositive ? (
                        <ArrowUp size={16} />
                      ) : (
                        <ArrowDown size={16} />
                      )}
                      {stat.change}
                    </div>
                  </div>
                  <div
                    style={{
                      ...styles.iconBox,
                      backgroundColor: stat.bgColor,
                    }}
                  >
                    <Icon size={24} color={stat.color} />
                  </div>
                </div>
              </div>
            );
          })}
        </div>
  
        {/* Content Grid */}
        <div style={styles.contentGrid}>
          {/* Recent Activities */}
          <div style={styles.card}>
            <h2 style={styles.cardTitle}>Recent Activities</h2>
            <div>
              {recentActivities.map((activity) => (
                <div key={activity.id} style={styles.activityItem}>
                  <div style={styles.activityTitle}>{activity.title}</div>
                  <div style={styles.activityMeta}>
                    <span>{activity.user}</span>
                    <span>{activity.time}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
  
          {/* Upcoming Tasks */}
          <div style={styles.card}>
            <h2 style={styles.cardTitle}>Upcoming Tasks</h2>
            <div>
              {upcomingTasks.map((task) => {
                const priorityColors = getPriorityColor(task.priority);
                return (
                  <div
                    key={task.id}
                    style={styles.taskItem}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = '#f1f5f9';
                      e.currentTarget.style.borderColor = '#cbd5e1';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = '#f8fafc';
                      e.currentTarget.style.borderColor = '#e2e8f0';
                    }}
                  >
                    <div style={styles.taskHeader}>
                      <div style={styles.taskTitle}>{task.title}</div>
                      <span
                        style={{
                          ...styles.priorityBadge,
                          backgroundColor: priorityColors.bg,
                          color: priorityColors.color,
                        }}
                      >
                        {task.priority}
                      </span>
                    </div>
                    <div style={styles.taskDeadline}>{task.deadline}</div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    );
  };
  
  export default Dashboard;